<template>
  <div class="article-add">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/community-management' }">社区管理</el-breadcrumb-item>
      <el-breadcrumb-item>社区添加</el-breadcrumb-item>
    </el-breadcrumb>


    <div class="upload-qrcode">
      <div>

        <div class="address-form">
          <el-cascader
            v-model="selectedOptions"
            :options="regionData"
            placeholder="请选择省市区"
            clearable
          ></el-cascader>
          <el-input
            placeholder="请输入街道名称"
            class="edit"
            v-model="title"
            type="textarea"
            autosize>
          </el-input>

        </div>

      </div>
      <button class="submit-button" @click="submit">确定</button>
      <div class="upload-container">
      </div>
      <div class="preview-container">

        <span v-if="!previewImage" class="placeholder-text">请先填写省市信息</span>
        <img v-else :src="previewImage" alt="Uploaded QR Code" />
      </div>
      <button class="submit-button" @click="downLoad" >点击下载二维码</button>
    </div>

  </div>
</template>


<script>
import { regionData, codeToText, provinceAndCityData,  } from 'element-china-area-data';
import fa from "element-ui/src/locale/lang/fa";

export default {

  data() {
    return {
      regionData: regionData,
      previewImage: '',
      title:'',
      options: regionData,
      selectedOptions: [],
    }
  },
  methods:{






    translate(){
      // 声明一个新数组
      let address = []
      // 遍历旧数组，push每个转译后编码进去address
      this.selectedOptions.forEach(item => {
        address.push(codeToText[item])
      })
      return address
    },



    submit() {

      if(this.selectedOptions.length==0){
        this.$msg('请填写省市区！');
        return false;
      }
      if(!this.title){
        this.$msg('请填写社区名称！');
        return false;
      }



      let address=this.translate(this.selectedOptions)
      let  province1=address[0];
      let  city1=address[1];
      let  district1=address[2]
      let data ={
        province:province1,
        city:city1,
        district:district1,
        community_name:this.title,
      };
      this.$post('/v1/admin/community',data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.goOff()
            this.previewImage=res.data.data.qrcode_url

          } else {
            this.$msg(res.data.msg)
          }
        });



    },


    downLoad(){
      if(this.selectedOptions.length==0){
        this.$msg('请填写省市区！');
        return false;
      }
      if(!this.title){
        this.$msg('请填写社区名称！');
        return false;
      }
      if(!this.previewImage){
        this.$msg('请等待图片传输！');
        return false;
      }
      let address=this.translate(this.selectedOptions)
      let  province1=address[0];
      let  city1=address[1];
      let  district1=address[2]
      const link = document.createElement('a');
      link.href = this.previewImage;
      link.target = '_blank';
      link.download = province1+'-'+city1+'-'+district1+'-'+this.title+'-'+'.png'; // 设置下载的文件名

      // 将链接元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击链接进行下载
      link.click();

      // 移除链接元素
      document.body.removeChild(link);

      this.title=''
      this.selectedOptions=[];
      this.previewImage=''

    },






    goOff(){
      // this.$router.go(-1);
    },
    goTo(path,id){
      this.$router.push({
        path:path,
        query:{
          id:id
        }
      })
    },

  },


  created() {
    // this.getVariety()
  }

}
</script>

<style lang="stylus" rel="stylesheet/">
.upload-qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;

}
.address-form{
  width: 300px;
  margin: 0 auto;
}

.upload-container {
  margin-bottom: 20px;
}

.upload-button {
  margin-top: 40px;
  display: inline-block;
  padding: 12px 20px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}

#file-input {
  display: none;
}
.el-textarea{
  margin-top: 30px;
}
.preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  border: 1px solid #ccc; /* 添加边框样式 */
  width: 300px; /* 设置图片框的宽度 */
  height: 300px; /* 设置图片框的高度 */
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-container {
  /* ... 其他样式设置 ... */
  position: relative;
}

.placeholder-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #999;
}
.preview-container img {
  max-width: 100%; /* 图片宽度最大不超过父容器 */
  max-height: 100%; /* 图片高度最大不超过父容器 */
}

.submit-button {
  margin-top: 30px;
  padding: 12px 20px;
  background-color: #409eff;
  color: #fff;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/CommunityManagement/CommunityAdd.vue